import { useTheme } from "next-themes";
import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import { Toaster } from "sonner";

const neutralIconClassName = "size-4 text-zinc-700 dark:text-zinc-300";

export function AppToaster() {
  const { resolvedTheme } = useTheme();
  const toasterTheme =
    resolvedTheme === "light" || resolvedTheme === "dark"
      ? resolvedTheme
      : "system";

  return (
    <Toaster
      position="top-center"
      theme={toasterTheme}
      closeButton
      offset={{
        top: "calc(4.75rem + env(safe-area-inset-top))",
        bottom: "calc(4.75rem + env(safe-area-inset-bottom))",
      }}
      mobileOffset={{
        top: "calc(4.5rem + env(safe-area-inset-top))",
        bottom: "calc(4.5rem + env(safe-area-inset-bottom))",
        left: 16,
        right: 16,
      }}
      icons={{
        success: <CircleCheck className={neutralIconClassName} />,
        info: <Info className={neutralIconClassName} />,
        warning: <TriangleAlert className={neutralIconClassName} />,
        error: <CircleAlert className="size-4 text-destructive" />,
      }}
      toastOptions={{
        duration: 4_000,
        classNames: {
          toast:
            "!rounded-lg !border !border-zinc-200 !bg-white !text-zinc-900 !shadow-md dark:!border-zinc-800 dark:!bg-zinc-950 dark:!text-zinc-50",
          description: "!text-zinc-500 dark:!text-zinc-400",
          actionButton:
            "!rounded-md !bg-zinc-900 !text-white hover:!bg-zinc-800 dark:!bg-zinc-50 dark:!text-zinc-950 dark:hover:!bg-zinc-200",
          cancelButton:
            "!rounded-md !bg-zinc-100 !text-zinc-900 hover:!bg-zinc-200 dark:!bg-zinc-900 dark:!text-zinc-50 dark:hover:!bg-zinc-800",
        },
      }}
    />
  );
}
